module.exports = __webpack_public_path__ + "static/img/anos_2000.41b34c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/linha-tempo/anos_2000.png
// module id = 6zOf
// module chunks = 0